<template>
  <article
    class="activity-card"
    :class="[`state-${activity.stateClass}`]"
    @click="emit('open', activity)"
  >
    <div class="activity-banner">
      <EncryptedImg
        v-if="activity.coverUrl"
        class="banner-img"
        :url="activity.coverUrl"
        :key-hex="activity.coverKey"
        fit="cover"
      />
      <!-- display 模板纯图；其余模板背景图 + 标题叠加 -->
      <div v-if="activity.templateCode !== 'display'" class="card-overlay">
        <div class="card-title">{{ activity.name }}</div>
      </div>
      <button
        v-if="activity.actionLabel"
        type="button"
        class="card-btn"
        :disabled="!activity.actionEnabled"
        @click.stop="emit('action', activity)"
      >
        {{ activity.actionLabel }}{{ activity.actionEnabled ? ' ›' : '' }}
      </button>
    </div>
  </article>
</template>

<script setup lang="ts">
import EncryptedImg from '~/components/EncryptedImg.vue'
import type { PromoActivity } from '../types'

defineProps<{ activity: PromoActivity }>()

const emit = defineEmits<{
  action: [activity: PromoActivity]
  open: [activity: PromoActivity]
}>()
</script>

<style scoped lang="scss">
.activity-card {
  min-width: 0;
  cursor: pointer;
  animation: promo-rise 0.28s ease-out backwards;
  animation-delay: calc(var(--i, 0) * 40ms);
  transition: transform 0.15s ease-out;

  &:active {
    transform: scale(0.985);
    transition-duration: 0.06s;
  }
}

.activity-banner {
  position: relative;
  height: 100px;
  border-radius: var(--r-lg);
  overflow: hidden;
  margin-bottom: 11px;
  box-shadow: var(--shadow-sm);
  background-image: linear-gradient(100deg, #4a1420, #1c0a12 62%);
}

.activity-banner .banner-img {
  position: absolute;
  inset: 0;
}

.card-overlay {
  position: absolute;
  top: 12px;
  left: 14px;
  right: 84px;
  z-index: 2;
}

.card-title {
  font-size: 19px;
  font-weight: 900;
  letter-spacing: 0.5px;
  line-height: 1.15;
  background: linear-gradient(#fff7dd, var(--gold-hi) 55%, var(--gold-deep));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.35));
}

.card-btn {
  position: absolute;
  left: 14px;
  bottom: 12px;
  z-index: 2;
  padding: 6px 15px;
  border-radius: var(--r-pill);
  background: var(--cta-go);
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  box-shadow: 0 4px 12px rgba(255, 90, 30, 0.35);
}

.state-claimable .card-btn {
  background: var(--cta-claim);
}

.state-progress .card-btn,
.state-waiting .card-btn,
.card-btn:disabled {
  background: var(--cta-wait-bg);
  color: rgb(255 255 255 / 68%);
  box-shadow: none;
}

.state-claimed {
  opacity: var(--claimed-opacity);
  filter: var(--claimed-filter);
}
</style>
